<button
  type="button"
  (click)="toggle()"
  [attr.aria-label]="state.ariaLabel | cxTranslate"
>
  <span aria-hidden="true">
    <cx-icon [type]="state.icon"></cx-icon>
  </span>
</button>
